type AccountOrganization = components['schemas']['Organization'] & {
  super_admin?: number | null
}

export function useOrganization() {
  const currentOrganization = useState<AccountOrganization | null>(
    'currentOrganization',
    () => null
  )
  const organizationCounts = useState<
    components['schemas']['OrganizationCounts'] | null
  >('organizationCounts', () => null)

  const { $api } = useNuxtApp()
  const clearOrganization = () => {
    currentOrganization.value = null
  }

  const setCounts = async () => {
    if (!currentOrganization.value) return

    await $api<components['schemas']['OrganizationCounts']>(
      `/organizations/${currentOrganization.value.id}/counts/`
    ).then((response) => (organizationCounts.value = response))
  }

  const refreshOrganization = async () => {
    if (!currentOrganization.value) return

    await $api<AccountOrganization>(
      `/organizations/${currentOrganization.value.id}/`
    ).then((response) => (currentOrganization.value = response))
  }

  const setOrganization = (organization?: AccountOrganization) => {
    if (!organization) return

    currentOrganization.value = organization
  }

  return {
    clearOrganization,
    currentOrganization,
    setCounts,
    organizationCounts,
    refreshOrganization,
    setOrganization,
  }
}
